import React, { ReactNode } from "react";
import classNames from "classnames";

import Tooltip from "@/components/Tooltip";

type Props = {
  title: string;
  className?: string;
  children?: ReactNode;
  sectionName?: string;
  shouldShowTooltip?: boolean;
  tooltipText?: string;
};

const TooltipCTA = ({
  title,
  children,
  className,
  sectionName = "",
  shouldShowTooltip = true,
  tooltipText,
}: Props) => (
  <div className={classNames("flex items-center text-xs mb-md", className)}>
    <div>{title}</div>
    {shouldShowTooltip && (!!tooltipText || children) && (
      <Tooltip
        dialogClass="-left-[292px] top-[24px] w-[288px]"
        text={tooltipText}
        placement="top-right"
        tooltipId={`show-${sectionName}-tooltip`}
        containerClass="!ml-1 !mt-0 h-[16px]"
        height={16}
        width={16}
      >
        {children}
      </Tooltip>
    )}
  </div>
);

export default TooltipCTA;
